"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'register.form.hero.title': 'Unisciti a IntHub',
    'register.form.hero.description': 'Per favore usa questo modulo per registrarti.',
    'register.form.hero.login_link_text': 'Se sei già membro, per favore',
    'register.form.hero.login_link': 'accedi qui.',
};
